import { DatePicker, Space } from 'antd'
import moment from 'moment'
import React from 'react'

const { RangePicker } = DatePicker

const DateCreator = ({
  from,
  to,
  dateFormat,
  picker,
  style,
}) => (
  <Space width="200">
    <RangePicker
      style={style}
      format={dateFormat}
      picker={picker}
      defaultValue={[
        moment(from, dateFormat),
        moment(to, dateFormat),
      ]}
      disabled
    />
  </Space>
)

export default DateCreator
